import AccountMenu from './account-menu';

export default AccountMenu;
